import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import StatCard from "./StatCard";
import DataTable from "./DataTable";
import HorizontalBarChartCard from "./HorizontalBarChartCard";
import BACKEND_URL from "../../config/config.js";
import "../../App.css";

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [registrosTotales, setRegistrosTotales] = useState(0);
  const [emisionesTotales, setEmisionesTotales] = useState(0);
  const [estimativoPercapita, setEstimativoPercapita] = useState(0);
  const [participacionPorcentaje, setParticipacionPorcentaje] = useState(0);
  const [emissions, setEmissions] = useState([]);

  const navigate = useNavigate();

  const getChartData = (items, names) =>
    items
      .filter((item) => names.includes(item.name))
      .sort((a, b) => b.KgCO2e - a.KgCO2e);

  const fixedNames = ["Energía eléctrica", "Consumo gas", "Logística"];
  const dynamicNames = ["Traslado aéreo", "Traslado terrestre", "Hotelería"];

  const chartFixed = getChartData(data, fixedNames);
  const chartDynamic = getChartData(data, dynamicNames);

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    fetch(`${BACKEND_URL}/visual-data`)
      .then((res) => res.json())
      .then((response) => {
        setData(response.data || []);
        setRegistrosTotales(response.registrosTotales || 0);
        setEmisionesTotales(response.emisionesTotales || 0);
        setEstimativoPercapita(response.estimativoPercapita || 0);
        setParticipacionPorcentaje(response.participacionPorcentaje || 0);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });

    fetch(`${BACKEND_URL}/dashboard-tables`)
      .then((res) => res.json())
      .then((response) => {
        setEmissions(response.emissions || []);
      })
      .catch((error) => {
        console.error("Error al obtener tablas del dashboard:", error);
      });
  }, []);

  return (
    <div className="container">
      <div className="printPageOne">
        <DashboardHeader
          logoSrc="/img/svant-logo.svg"
          logoAlt="Svant Measure and Act"
          logoClassName="logoSvant"
          actions={
            <>
              <button className="btnPrint" onClick={handlePrint}>
                Imprimir
              </button>
              <button onClick={() => navigate("/")}>Agregar registros</button>
            </>
          }
        />

        <div className="containerFlex">
          <StatCard
            title="Cantidad de registros"
            value={`${registrosTotales} registros`}
          />
          <StatCard
            title="Porcentaje participación"
            value={`${participacionPorcentaje.toFixed(2)} %`}
          />
        </div>

        <div className="containerFlex">
          <StatCard
            title="Emisión total del evento"
            value={`${emisionesTotales.toFixed(2)} Kg CO₂e`}
          />
          <StatCard
            title="Estimativo per capita"
            value={`${estimativoPercapita.toFixed(2)} Kg CO₂e`}
          />
        </div>

        <div className="containerFlex printChartsBlock">
          <HorizontalBarChartCard
            title="Emisiones fijas del evento"
            data={chartFixed}
          />
          <HorizontalBarChartCard
            title="Emisiones móviles del evento"
            data={chartDynamic}
          />
        </div>
      </div>

      <div className="printPageTwo printUsersTableSection">
        <DataTable
          title="Emisiones por usuario"
          data={emissions}
          rowKey="id_user_response"
          className="usersPrintTable"
          columns={[
            { key: "id_user_response", label: "ID" },
            { key: "first_name", label: "Nombre" },
            { key: "last_name", label: "Apellido" },
            { key: "travel_time", label: "Horas vuelo" },
            { key: "event_transport", label: "Transporte terrestre" },
            { key: "stayed_in_hotel", label: "¿Hotel?" },
            { key: "co2_total_per_user", label: "Total CO₂" },
          ]}
          renderRow={(e) => (
            <>
              <td>{e.id_user_response}</td>
              <td>{e.first_name}</td>
              <td>{e.last_name}</td>
              <td>{e.travel_time}</td>
              <td>{e.event_transport}</td>
              <td>{e.stayed_in_hotel ? "Sí" : "No"}</td>
              <td>
                <b>{Number(e.co2_total_per_user || 0).toFixed(2)} Kg</b>
              </td>
            </>
          )}
        />
      </div>

      <h4 className="printTitle">Reporte generado para</h4>
      <h4 className="printTitle">
        <b id="eventName"></b>
      </h4>
    </div>
  );
}
